import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RealTimeProvider } from "./contexts/RealTimeContext";
import { timeService } from "./services/timeService";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import TabletInterface from "./components/TabletInterface";

// Initialize time service on app start
timeService.initialize().catch(console.error);

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <RealTimeProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/tablet" element={<TabletInterface />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </RealTimeProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
